import { render } from "./MaterialSupplier.vue?vue&type=template&id=06e287bc&scoped=true"
import script from "./MaterialSupplier.vue?vue&type=script&lang=js"
export * from "./MaterialSupplier.vue?vue&type=script&lang=js"

import "./MaterialSupplier.vue?vue&type=style&index=0&id=06e287bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e287bc"]])

export default __exports__